import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getTotalNumOfAnalystics } from "../../../../../redux/action/analystics";
import HeaderLoading from "../../../../loader/HeaderLoading";

function AuctionAnalystic() {
  const dispatch = useDispatch();
  const isLaptop = useMediaQuery({ query: "(max-width: 1300px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 550px)" });
  const [auctionvalue, setAuctionvalue] = useState([]);
  const { analystics, loadings } = useSelector(
    (state) => state?.analysticsData
  );
  useEffect(() => {
    dispatch(getTotalNumOfAnalystics());
  }, [dispatch]);

  useEffect(() => {
    const logos = ["redo", "check_circle_outline", "wallet", "group"];
    const processes = [
      "Upcoming Auctions",
      "Win Auctions",
      "Completed Auctions",
      "Deposited Lots",
    ];

    const auctionDetailsArray = Object.keys(analystics).map((key, index) => ({
      key: key,
      value: analystics[key],
      logo: logos[index],
      process: processes[index],
    }));

    setAuctionvalue(auctionDetailsArray);
  }, [analystics]);
  

  if (loadings) {
    return <HeaderLoading />;
  }

  return (
    <div
      className="p-1 cover white gap-1"
      style={{
        display: "grid",
        gridTemplateColumns: isMobile
          ? "repeat(1,1fr)"
          : isLaptop
          ? "repeat(2,1fr)"
          : "repeat(4,1fr)",
        boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
      }}
    >
      {auctionvalue?.map((items, index) => (
        <div className="border-1px p-1 pointer border-radius-12" key={index}>
          <div className="valign-wrapper space-between">
            <h2 className="cercle-purple-text">{items?.value}</h2>
            <span
              className="material-icons-outlined cercle-purple white-text border-radius-12"
              style={{ padding: "0.7rem" }}
            >
              {items.logo}
            </span>
          </div>
          <p className="cercle-purple-text font-18px">{items.process}</p>
          <p className="valign-wrapper font-13px" style={{ color: "#7C8DB5" }}>
            <span className="material-icons-outlined font-18px green-text">
              north_east
            </span>
            <span className=" mr-1" style={{ marginLeft: "5px" }}>
              00.0 this week
            </span>
          </p>
        </div>
      ))}
    </div>
  );
}

export default AuctionAnalystic;
